export default __webpack_public_path__ + "static/media/pdf.3605161a.svg";